(function () {
    document.addEventListener("DOMContentLoaded", function () {
        let scrollThreshold = 370;

        function loadMoreJobs(paged, perPage) {
            // Capture form values
            const form = document.querySelector('#jobs-filter-form');
            const formData = new FormData(form); // This will capture all the form inputs
            
            let loadMoreButton = document.getElementById('load-more-jobs');

            let output = document.getElementById("filter-job-output");

            // If no more posts, remove the event listener
            window.removeEventListener("scroll", scrollHandler);

            // Ajax request
            let request = new XMLHttpRequest();
            
            request.open("POST", ajax_callback_data.ajax_url, true);
            request.setRequestHeader(
                "Content-Type",
                "application/x-www-form-urlencoded; charset=UTF-8"
            );

            // Prepare data for the POST request
            let postData = new URLSearchParams(formData).toString();

            // Add additional data like action and nonce if needed
            postData += `&action=yakkly_jobs&nonce=${ajax_callback_data.ajax_nonce}&page=${paged}&perPage=${perPage}`;
            
            request.send(postData);

            request.onreadystatechange = () => {
                if (request.readyState === 4) {
                    
                    let data = JSON.parse(request.response);

                    let totalPages = data.data.totalPages;
                    let currentPage = data.data.currentPage;
                    loadMoreButton.setAttribute("data-page", parseInt(currentPage));
                    let loadMoreElement = document.querySelector('.btn-loading');
                    loadMoreElement.remove();

                    if (totalPages > currentPage) {
                        loadMoreButton.style.display = "block";
                        window.addEventListener("scroll", scrollHandler);
                    } else {
                        loadMoreButton.style.display = "none";
                    }
                    output.innerHTML += data.data.html;

                }
            };
            
        }

        function scrollHandler() {
            let scrollPosition = window.innerHeight + window.scrollY;
            let documentHeight = document.documentElement.scrollHeight;

            if (scrollPosition >= documentHeight - scrollThreshold) {
                let loadMoreTag = document.getElementById('load-more-jobs');
                if (!loadMoreTag) return;
                let paged = loadMoreTag.getAttribute("data-page");
                let perPage = loadMoreTag.getAttribute("data-perpage");
                paged++;
                loadMoreTag.setAttribute("data-page", paged);
                let loaderDiv = document.createElement('div');
                loaderDiv.className = 'loader btn-loading w-100';
                loaderDiv.innerHTML = '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10 0C4.824 0 0.553781 3.954 0.0507812 9H2.06836C2.56336 5.06 5.928 2 10 2C14.072 2 17.4366 5.06 17.9316 9H19.9492C19.4452 3.954 15.176 0 10 0ZM0.0507812 11C0.250781 13.008 1.05458 14.8374 2.26758 16.3184L3.6875 14.8984C2.8295 13.7924 2.25136 12.457 2.06836 11H0.0507812ZM16.2715 14.9297C15.8575 15.4547 15.3855 15.9328 14.8555 16.3398L15.8672 18.0742C16.6802 17.4832 17.399 16.7698 18.002 15.9668L16.2715 14.9297ZM5.10352 16.3105L3.68164 17.7324C4.98764 18.8014 6.56592 19.5496 8.29492 19.8516L8.4375 17.8398C7.2005 17.5918 6.06452 17.0595 5.10352 16.3105ZM13.1309 17.3516C12.2949 17.7086 11.3846 17.9285 10.4316 17.9805L10.2891 19.9863C11.6611 19.9473 12.9606 19.621 14.1406 19.082L13.1309 17.3516Z" fill="#385CDD" /></svg>';

                // Check if parentNode exists before inserting the loader
                if (loadMoreTag.parentNode){
                    loadMoreTag.parentNode.insertBefore(loaderDiv, loadMoreTag);
                };

                // Ensure function exists before calling
                if (typeof loadMoreJobs === "function"){
                    loadMoreJobs(paged, perPage);
                } else {
                    console.error("Error: loadMoreJobs function is not defined.");
                }
            }
        }

        window.addEventListener("scroll", scrollHandler);
       
    });
    /**
     * Add redirection url to login button if going through restrict access page
     * so that they can come back to the page once logged in
     * @type {Element}
     */
    const restrictedAccess = document.querySelector('.restrict-access-wrap');

    if (restrictedAccess) {
        const loginButtons = document.querySelectorAll('.login-button');
        const currentUrl = window.location.href;
        // get all the login button
        loginButtons.forEach((button) => {
            const link = button.getAttribute('href');

            if (link && link.includes('/login')) {
                const loginUrl = new URL(link, window.location.origin);
                loginUrl.searchParams.set('redirect_to', currentUrl); // add the redirect url
                button.setAttribute('href', loginUrl.toString());
            }
        });
    }

})();